import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private userPermissions = new BehaviorSubject<string[]>([]);
  
  constructor() { 
    this.loadPermissionsFromStorage();
  }

  private loadPermissionsFromStorage(): void {
    try {
      const raw = localStorage.getItem('permissions');
      if (raw) {
        const permissions = JSON.parse(raw)
        this.setPermissions(permissions)
      }
    } catch (error) {
      console.error('Error loading permissions from storage', error);
    }
  }

  setPermissions(permissions: string[]): void {
    // how to join the permission the object is {permission_code:'sample'}
    localStorage.setItem('permissions', JSON.stringify(permissions));
    this.userPermissions.next(permissions);
  }

  getPermissions() {
    return this.userPermissions.asObservable();
  }

  hasPermission(permissionCode: string | string[]): boolean {
    if (!permissionCode || permissionCode === '') {
        return true;
    }
    
    if (Array.isArray(permissionCode)) {
        return permissionCode.some(code => 
            this.userPermissions.value.some((permission: any) => 
                permission.permission_code === code
            )
        );
    }
    
    return this.userPermissions.value.some((permission: any) => 
        permission.permission_code === permissionCode
    );
  }
}